module.exports = __webpack_public_path__ + "img/cover-spacepuzzle.2b5aee69.png";